import styled from '@emotion/styled';
export const MessageContainer = styled.div`
  display: flex;
  flex-direction: ${(props)=>props.isOwn ? 'row-reverse' : 'row'};
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0 1rem;
`;
export const MessageContent = styled.div`
  max-width: 70%;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;
export const MessageBubble = styled.div`
  padding: 0.75rem 1rem;
  border-radius: 1rem;
  background-color: ${(props)=>props.isOwn ? '#3b82f6' : '#f3f4f6'};
  color: ${(props)=>props.isOwn ? 'white' : '#1f2937'};
  word-wrap: break-word;
  position: relative;

  .dark & {
    background-color: ${(props)=>props.isOwn ? '#2563eb' : '#374151'};
    color: ${(props)=>props.isOwn ? 'white' : '#f3f4f6'};
  }
`;
export const MessageMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: #6b7280;
  ${(props)=>props.isOwn ? 'justify-content: flex-end;' : ''}

  .dark & {
    color: #9ca3af;
  }
`;
export const SenderName = styled.span`
  font-weight: 500;
`;
export const MessageTime = styled.span`
  opacity: 0.7;
`;
export const ReplyIndicator = styled.div`
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  background-color: rgba(0, 0, 0, 0.05);
  border-left: 3px solid #3b82f6;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: #6b7280;

  .dark & {
    background-color: rgba(255, 255, 255, 0.05);
    color: #9ca3af;
  }
`;
export const MessageActions = styled.div`
  display: flex;
  gap: 0.25rem;
  opacity: 0;
  transition: opacity 0.2s;
  ${(props)=>props.isOwn ? 'justify-content: flex-end;' : ''}

  ${MessageContainer}:hover & {
    opacity: 1;
  }
`;
export const ActionButton = styled.button`
  padding: 0.25rem 0.5rem;
  border-radius: 0.375rem;
  border: none;
  background-color: #f3f4f6;
  color: #6b7280;
  font-size: 0.75rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #e5e7eb;
    color: #374151;
  }

  .dark & {
    background-color: #374151;
    color: #9ca3af;

    &:hover {
      background-color: #4b5563;
      color: #d1d5db;
    }
  }
`;
export const MediaPreview = styled.div`
  margin-top: 0.5rem;
  border-radius: 0.5rem;
  overflow: hidden;
  max-width: 20rem;

  img, video {
    width: 100%;
    height: auto;
    display: block;
  }
`;
export const MessageStatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #9ca3af;
  ${(props)=>props.isOwn ? 'justify-content: flex-end;' : ''}
  margin-top: 0.25rem;
`;
export const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  
  svg {
    width: 0.875rem;
    height: 0.875rem;
  }
  
  ${(props)=>{
    switch(props.status){
        case 'sending':
            return 'color: #9ca3af;';
        case 'sent':
            return 'color: #6b7280;';
        case 'delivered':
            return 'color: #3b82f6;';
        case 'read':
            return 'color: #10b981;';
        case 'failed':
            return 'color: #ef4444; cursor: pointer;';
        default:
            return 'color: #9ca3af;';
    }
}}
`;
export const StatusText = styled.span`
  ${(props)=>props.status === 'failed' ? 'color: #ef4444;' : ''}
`;
export const RetryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.25rem;
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  font-size: 0.75rem;
  border-radius: 0.25rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: #fef2f2;
  }

  .dark &:hover {
    background-color: #450a0a;
  }
`;
